<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'ShippingCommission',
})
</script>
<template>
  <div class="shippingCommission">
    <header>
      <NavBar :title="lang('寄件提成')"></NavBar>
    </header>
    <Filter
      :source-enum="sourceEnum"
      :source-enum-type="sourceTypeEnum"
      :checked="checked"
      :search-text="searchText"
      :source="source"
      :source-type="sourceType"
      :start-date="startDate"
      :end-date="endDate"
      @reset="reset"
      @confirm="filterConfirm"
    />
    <div class="scroll">
      <PullRefresh
        v-model:refreshing="refreshing"
        :scroll-height="'100%'"
        class="pull"
        @on-refresh="pageFn"
      >
        <div style="height: 8px"></div>
        <Total
          :list="collectList"
          :total="collectTotal"
          :image="collection"
          :name="lang('揽收量汇总')"
        />
        <div style="height: 8px"></div>
        <Total
          :list="commissionList"
          :image="commission"
          :total="commissionTotal"
          :name="lang('提成金额汇总(PHP)') + ':'"
        />
        <div style="height: 8px"></div>
        <Table :list="list" />
        <no-data v-if="list.length === 0" />
      </PullRefresh>
    </div>
  </div>
</template>

<script lang="ts" setup name="ShippingCommission">
import { ref } from 'vue'
import NavBar from '@core/components/NavBar.vue'
import lang from '@/langs'
import Filter from '@/views/shippingCommission/component/filter.vue'
import Total from '@/views/shippingCommission/component/total.vue'
import Table from '@/views/shippingCommission/component/table.vue'
import commission from '@/assets/images/shippingCommission/commission.png'
import collection from '@/assets/images/shippingCommission/collection.png'
import { bankList } from '@/api/requests/score'
import { showToast } from 'vant'
import { CommonModel } from '@/model/common/commonModel'
import { queryList, queryStatistics } from '@/api/requests/shippingCommission'
import { getFormattedDate } from '@core/utils/aboutDate'
import {
  getShippingCommissionListResp,
  QueryStatisticsModel,
  QueryStatisticsRespModel
} from '@/model/shippingCommission/main'
import PullRefresh from '@core/components/PullRefresh.vue'
import NoData from '@core/components/NoData.vue'
//揽收汇总
const collectList = ref([
  { name: lang('平台件'), value: '0' },
  { name: lang('回退件'), value: '0' },
  { name: lang('散户'), value: '0' }
])
//提成汇总
const commissionList = ref([
  { name: lang('平台件'), value: '0' },
  { name: lang('回退件'), value: '0' },
  { name: lang('散户'), value: '0' }
])
//订单来源
const source = ref<string | number>(0)
//订单来源类型
const sourceType = ref<string | number>(0)
//搜索关键字
const searchText = ref('')
// 开始时间
const startDate = ref(getFormattedDate())
// 结束时间
const endDate = ref(getFormattedDate())
// 1,寄件日期 2。入库日期
const checked = ref('1')
// 来源枚举
const sourceEnum = ref<CommonModel[]>([])
// 来源类型枚举
const sourceTypeEnum = ref<CommonModel[]>([])
// 揽收汇总
const collectTotal = ref(0)
// 提成汇总
const commissionTotal = ref(0)
// 列表数据
const list = ref<(string | number)[][]>([])
const refreshing = ref(false)
// 接口入参
let param: QueryStatisticsModel = {
  timeType: Number(checked.value),
  timeStart: startDate.value.join('-'),
  timeEnd: startDate.value.join('-'),
  waybillCode: searchText.value,
  orderSourceCode: source.value === 0 ? '' : source.value,
  orderSourceType: sourceType.value === 0 ? '' : sourceType.value
}
// 请求接口时用函数返回这样每次拿的都是最新的数据
const paramFn = (): QueryStatisticsModel => {
  param.orderSourceCode =
    param.orderSourceCode == 0 ? '' : param.orderSourceCode
  param.orderSourceType =
    param.orderSourceType == 0 ? '' : param.orderSourceType
  const temp = {
    timeStart: param.timeStart + ' 00:00:00',
    timeEnd: param.timeEnd + ' 23:59:59'
  }
  return { ...param, ...temp }
}
// 来源枚举
const getEnum = () => {
  bankList('orderSourceCode').then((value) => {
    if (value.code === 1) {
      let temp = [
        ...[{ dictKey: lang('全部'), dictValue: 0 }],
        ...(value?.data?.records || [])
      ]
      sourceEnum.value =
        temp.map((item, i) => {
          return { value: i, text: item.dictKey, code: item.dictValue }
        }) || []
    } else {
      showToast(lang(value?.msg) || 'Service exception, please try again later')
    }
  })
}
// 来源类型枚举
const getEnumType = () => {
  bankList('orderSourceType').then((value) => {
    if (value.code === 1) {
      let temp = [
        ...[{ dictKey: lang('全部'), dictValue: 0 }],
        ...(value?.data?.records || [])
      ]
      sourceTypeEnum.value =
        temp.map((item, i) => {
          return { value: i, text: item.dictKey, code: item.dictValue }
        }) || []
    } else {
      showToast(lang(value?.msg) || 'Service exception, please try again later')
    }
  })
}
// 筛选组件点击确认时触发的
const filterConfirm = (value: QueryStatisticsModel) => {
  param = { ...param, ...value }
  source.value = value.orderSourceCode
  sourceType.value = value.orderSourceType
  searchText.value = value.waybillCode
  startDate.value = value.timeStart.split('-')
  endDate.value = value.timeEnd.split('-')
  checked.value = value.timeType + ''

  pageFn()
}
const reset = (value: QueryStatisticsModel) => {
  param = { ...param, ...value }
  source.value = value.orderSourceCode
  sourceType.value = value.orderSourceType
  searchText.value = value.waybillCode
  startDate.value = value.timeStart.split('-')
  endDate.value = value.timeEnd.split('-')
  checked.value = value.timeType + ''
}
// 汇总数据处理
const getData = (value: QueryStatisticsRespModel) => {
  collectTotal.value = value.collection
  commissionTotal.value = value.amount
  collectList.value[0].value = value.collectionPlatform + ''
  collectList.value[1].value = value.collectionReturn + ''
  collectList.value[2].value = value.collectionThrowaway + ''
  commissionList.value[0].value = value.amountPlatform + ''
  commissionList.value[1].value = value.amountReturn + ''
  commissionList.value[2].value = value.amountThrowaway + ''
}
// 列表数据处理API
const getList = (value: getShippingCommissionListResp[]) => {
  list.value =
    value?.map((e) => {
      return [
        e.waybillNo,
        e.deliveryTime,
        e.enterTime,
        e.incentiveAmount,
        e.totalFreight
      ]
    }) || []
}
// 汇总+列表接口请求
const pageFn = () => {
  refreshing.value = true
  Promise.all([queryStatistics(paramFn()), queryList(paramFn())])
    .then((res) => {
      getData(res[0].data)
      getList(res[1].data)
    })
    .finally(() => {
      refreshing.value = false
    })
}
//初始化，枚举接口调用位置
const init = () => {
  getEnum()
  getEnumType()
  pageFn()
}
init()
</script>
<style scoped lang="less">
.shippingCommission {
  height: 100vh;
  width: 100vw;
  display: flex;
  flex-direction: column;
  .scroll {
    flex: 1;
    overflow-y: hidden;
    overscroll-behavior: none;
  }
}
</style>
